import { DayPicker } from 'react-day-picker';
import 'react-day-picker/style.css';
import PropTypes from 'prop-types';
import Icon from '../../renders/icon/Icon';
import ICONS from '@/common-utils/enums/icons';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import { fr } from 'react-day-picker/locale';
import { useTranslation } from 'react-i18next';
import './calendar.scss';

/**
 *
 * @param root0
 * @param root0.className
 * @param root0.classNames
 * @param root0.selected
 * @param root0.onSelect
 * @param root0.showOutsideDays
 * @param root0.disableBeforeToday
 * @param root0.disableAfterToday
 * @returns {JSX}
 */
function Calendar({
  className,
  classNames,
  selected,
  onSelect,
  showOutsideDays = true,
  disableBeforeToday,
  disableAfterToday,
  ...props
}) {
  const i18n = useTranslation();
  const setLang = () => {
    switch (i18n.i18n.language) {
      case 'fr': {
        return fr;
      }
      default: return null;
    }
  };
  return (
    (<DayPicker
      selected={selected}
      onSelect={onSelect}
      disabled={(date) => disableBeforeToday && date < new Date() || disableAfterToday && date > new Date()}
      locale={setLang()}
      captionLayout='buttons'
      showOutsideDays={showOutsideDays}
      weekStartsOn={1}
      className={cn('p-3', className)}
      classNames={{
        today: 'text-primary',
        chevron: 'text-primary',
        ...classNames
      }}
      components={{
        IconLeft: ({ className, ...props }) => (
          <Icon icon={ICONS.CHEVRON_LEFT} className={cn('h-4 w-4', className)} {...props} />
        ),
        IconRight: ({ className, ...props }) => (
          <Icon icon={ICONS.MORE_INFO} className={cn('h-4 w-4', className)} {...props} />
        )
      }}

      {...props} />)
  );
}
Calendar.displayName = 'Calendar';

Calendar.propTypes = {
  className: PropTypes.string,
  classNames: PropTypes.object,
  selected: PropTypes.any,
  onSelect: PropTypes.func,
  showOutsideDays: PropTypes.bool,
  disableBeforeToday: PropTypes.bool,
  disableAfterToday: PropTypes.bool
};

export { Calendar };
